import './App.css';
import { Routes, Route } from 'react-router-dom';
import Main from './components/pages/main/main';
import OfferPage from './components/pages/offer/offer';
import PrivacyPage from './components/pages/privacy/privacy';
import AgreementPage from './components/pages/agreement/agreement';
import CookiesPage from './components/pages/cookies/cookies';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/offer" element={<OfferPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/agreement" element={<AgreementPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
      </Routes>
    </div>
  );
}

export default App;
